import React from 'react'
import clsx from 'clsx'
import { useGetLessonType } from '../api-hooks'
import useIconAccessor from 'components/lesson-type-category/icons'
import BookingAttachmentCard from './booking-attachment-card'
import { formatLessonTypeDetailLine } from './format-booking-attachment'

const UnableToRenderCard = ({ type }) => (
  <div
    className={clsx('str-chat__message-attachment-card', {
      [`str-chat__message-attachment-card--${type}`]: type,
    })}
  >
    <div className="str-chat__message-attachment-card--content">
      <div className="str-chat__message-attachment-card--text">
        this content could not be displayed
      </div>
    </div>
  </div>
)

const LessonTypeAttachmentCard = ({
  lesson_type_id: id,
  pga_booking_url: pgaBookingURL,
  booking_url: bookingUrl,
  type,
}) => {
  const resolvedBookingURL = pgaBookingURL || bookingUrl
  const accessor = useIconAccessor()
  const { data, loading, error } = useGetLessonType({ id, skip: !id })
  const lessonType = data?.lessonTypes?.[0]

  if (!id) {
    return <UnableToRenderCard type={type} />
  }

  if (loading) {
    return null
  }

  if (!resolvedBookingURL || error || !lessonType) {
    return <UnableToRenderCard type={type} />
  }

  const categoryIcon = accessor[lessonType.category]?.icon || accessor.OTHER.icon

  return (
    <BookingAttachmentCard
      bookingUrl={resolvedBookingURL}
      detailLine={formatLessonTypeDetailLine(lessonType)}
      fallbackIcon={categoryIcon}
      title={lessonType.title}
      type={type}
    />
  )
}

export default React.memo(LessonTypeAttachmentCard)
